import getValueFromCookies from 'utils/pivot/cookie/getValueFromCookies'

function getAgentAuthorizationToken() {
  const cookieVal = 'AG-Authorization='
  const REGEX = /^AG-Authorization=/

  return getValueFromCookies(cookieVal, REGEX)
}

export default getAgentAuthorizationToken
